/* eslint-disable no-undef */
import FavoriteRestoIdb from '../../data/favorite-resto-idb';
import { restoItemTemplate, createSkeletonRestoTemplate } from '../templates/template-creator';
import '../components/fail-request';

const Favorite = {
  async render() {
    return `
    <h1 class="main-title" id="konten">Favorite Restaurant</h1>
    <article class="container-content" id="katalog">
      ${createSkeletonRestoTemplate(20)}
    </article>`;
  },

  async afterRender() {
    const loading = document.querySelector('loading-element');
    const fail = document.querySelector('fail-request');
    loading.style.display = 'block';
    fail.style.display = 'none';
    try {
      const data = await FavoriteRestoIdb.getAllRestos();
      if (data.length === 0) {
        katalog.innerHTML = '<p class="nullFav" id="nullFav">Tidak ada data</p>';
      } else {
        const katalog = document.getElementById('katalog');
        katalog.innerHTML = '';
        data.forEach((item) => {
          katalog.innerHTML += restoItemTemplate(item);
        });
      }
    } catch {
      fail.style.display = 'block';
      const footer = document.querySelector('footer');
      const main = document.getElementById('main');
      const hero = document.getElementById('hero');
      main.style.display = 'none';
      hero.style.display = 'none';
      footer.style.display = 'none';
    } finally {
      loading.style.display = 'none';
    }
  },
};

export default Favorite;
